import React from "react";
import TextField from "./components/TextField";
import TextArea from "./components/TextArea";
import Number from "./components/Number";
import Decimal from "./components/Decimal";
import CustomSelect from "./components/CustomSelect";
import CustomMultiSelect from "./components/CustomMultiSelect";
import Label from "./components/Label";
import Checkbox from "./components/Checkbox";
import SelectBoxes from "./components/SelectBoxes";
import Radio from "./components/Radio";
import Password from "./components/Password";
import CustomDate from "./components/CustomDate";
import PhoneNumber from "./components/PhoneNumber";
import Email from "./components/Email";
import File from "./components/File";
import store from "../../../store";
import { setRendererFormState } from "../../../store/slices/commonSlice";
import DatePicker from "./components/Date";
import CustomYear from "./components/CustomYear";

export const renderElement = (
  item,
  fields,
  formState,
  setFormState,
  fun,
  index,
  ind
) => {
  // Function to check bootstrap validation
  (() => {
    const forms = document.querySelectorAll(".form-details");
    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  })();

  const newElfromJSON = item.elementid + "-" + item.elementtype;
  let displayLabelKey = fields[newElfromJSON]?.["display-fieldlabel"];
  if (displayLabelKey) {
    displayLabelKey = displayLabelKey
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/:/g, "");
  }

  let databaseKey = fields[newElfromJSON]?.["database-label"];
  if (displayLabelKey) {
    displayLabelKey = displayLabelKey
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/:/g, "");
  }

  switch (item.elementtype) {
    case "textfield":
      return (
        <TextField
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "textarea":
      return (
        <TextArea
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "number":
      return (
        <Number
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "decimal":
      return (
        <Decimal
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "select":
      return (
        <CustomSelect
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "multiselect":
      return (
        <CustomMultiSelect
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "customDate":
      return (
        <CustomDate
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "year":
      return (
        <CustomYear
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "label":
      return (
        <Label
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
        />
      );
    case "checkbox":
      return (
        <Checkbox
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "selectboxes":
      return (
        <SelectBoxes
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "radio":
      return (
        <Radio
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "password":
      return (
        <Password
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "date":
      return (
        <DatePicker
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "phoneNumber":
      return (
        <PhoneNumber
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "email":
      return (
        <Email
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "file":
      return (
        <File
          arrEle={item}
          newElfromJSON={newElfromJSON}
          fieldEle={fields[newElfromJSON]}
          formState={formState}
          displayLabelKey={displayLabelKey}
          databaseKey={databaseKey}
        />
      );
    case "fieldset":
      const displayDependent = fields[newElfromJSON]?.["display-dependent"];
      const displayIndex = fields[newElfromJSON]?.["display-index"];
      const dependentValue =
        displayDependent && formState ? formState[displayDependent] : "";
      const shouldDisplayDependent =
        !displayDependent ||
        (dependentValue && parseInt(dependentValue) >= parseInt(displayIndex));

      if (displayDependent && !shouldDisplayDependent) {
        return null;
      }
      return (
        <div
          className="form-group formarea-component"
          data-elementtype="fieldset"
          id={item.elementid}
          style={{
            display: "block",
            visibility: fields[newElfromJSON]?.["display-hidden"] === 1 ? "hidden" : "",
            marginBottom: "25px",
          }}
        >
          <fieldset
            className="form-fieldset-design"
            id={newElfromJSON}
          >
            <legend
              id={`${newElfromJSON}-legend`}
            >
              {fields[newElfromJSON]?.["display-legend"]
                ? fields[newElfromJSON]?.["display-legend"]
                : fields[newElfromJSON]?.["display-fieldlabel"]}
            </legend>
            <div
              className="fieldset-body formarea-component-fieldset mt-3"
              id={`${newElfromJSON}-body`}
            >
              {item.child.map((child) =>
                renderElement(child, fields, formState, setFormState)
              )}
            </div>
          </fieldset>
        </div>
      );
    case "column":
      return (
        <div
          className={`${item.colsizeclass} formarea-component-column form-group`}
          data-colpos={item.colpos}
          data-colsize={item.colsizeclass}
          id={item.elementid}
        >
          {item.child.map((child) =>
            renderElement(child, fields, formState, setFormState)
          )}
        </div>
      );
    case "columns":
      return (
        <div
          className="form-group formarea-component formarea-component-columns"
          data-elementtype="columns"
          id={item.elementid}
        >
          <div
            className="row"
            id={`${item.elementid}-columns`}
            data-colsize={item.colsize}
          >
            {item.child.map((child) =>
              renderElement(child, fields, formState, setFormState)
            )}
          </div>
        </div>
      );
    case "section":
      return (
        <div id={item.elementid} className="form-group">
          <div className="formarea-form" id={`${item.elementid}-form`}>
            <span
              className={`tab-label nav-link ${index === ind ? "active" : ""}`}
              onClick={fun}
            >
              {item.name}
            </span>
            {/* {item.child.map((child) =>
              renderElement(child, fields, formState, setFormState)
            )} */}
          </div>
        </div>
      );
    default:
      return null;
  }
};

const getDisplayLabelKeys = (layout, fields) => {
  let displayLabelKeys = [];

  const processLayout = (layout) => {
    layout.forEach((item) => {
      if (item.child && item.child.length > 0) {
        processLayout(item.child);
      }

      const newElfromJSON = item.elementid + "-" + item.elementtype;
      const databaseKey = fields[newElfromJSON]?.["database-label"];
      const displayLabelKey = fields[newElfromJSON]?.["display-fieldlabel"];

      if (displayLabelKey || databaseKey) {
        if (databaseKey) {
          const processedDisplayLabelKey = databaseKey
            .trim()
            .toLowerCase()
            .replace(/[\s:.-]/g, "_"); // remove space, - and :
          displayLabelKeys.push(processedDisplayLabelKey);
        } else {
          const processedDisplayLabelKey = displayLabelKey
            .trim()
            .toLowerCase()
            .replace(/[\s:.-]/g, "_"); // remove space, - and :
          displayLabelKeys.push(processedDisplayLabelKey);
        }
      }
    });
  };

  processLayout(layout);

  return displayLabelKeys;
};

export function initializeFormState(layoutJSON, fieldsJSON, formState) {
  let ignoreList = ["section", "column", "columns", "field_set", "label"];
  const displayLabelKeys = getDisplayLabelKeys(layoutJSON, fieldsJSON);

  const emptyFormState = displayLabelKeys.reduce((acc, displayLabelKey) => {
    if (!ignoreList.includes(displayLabelKey)) {
      return {
        ...acc,
        [displayLabelKey]: formState[displayLabelKey] || "",
      };
    }
    return acc;
  }, {});

  store.dispatch(setRendererFormState(emptyFormState));
}
